export default "__VITE_ASSET__708266d2__"